"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrrationalManager = void 0;
var Utils_1 = require("./Utils");
var irrationals_1 = require("./irrationals");
var SternBorcot_1 = require("./SternBorcot");
var OutputParsers_1 = require("./OutputParsers");
var IrrationalManager = /** @class */ (function (_super) {
    __extends(IrrationalManager, _super);
    function IrrationalManager(generate, output) {
        if (generate === void 0) { generate = false; }
        if (output === void 0) { output = "default"; }
        var _this = _super.call(this) || this;
        _this.table = {};
        _this.rationalTableTerminating = {};
        _this.rationalTableNonTerminating = {};
        _this.output = IrrationalManager.outputModeTable[output];
        if (generate)
            _this.fillTable(IrrationalManager.irrationals);
        else {
            _this.table = irrationals_1.irrational_table;
            _this.rationalTableTerminating = irrationals_1.rational_table_terminating;
            _this.rationalTableNonTerminating = irrationals_1.rational_table_non_terminating;
        }
        return _this;
    }
    // For now this is just going to iterate over the returned fractions. Later though, we'll be able to be smarter about
    // this by prioritizing certain fractions by their relative likelihood of occurring
    IrrationalManager.prototype.find_best_fraction = function (input) {
        var round_target = Utils_1.sigfigs(input);
        var possible_fractions = this.find_many_fractions(input, round_target);
        var selected_fraction = IrrationalManager.getFirstResult(possible_fractions);
        // If round target is less than like 3, prioritize simpler fractions (fractions with 1 on numerator or denominator)
        if (round_target < 3) {
        }
        if (IrrationalManager.validateAnswer(selected_fraction, round_target)) {
            return [
                this.output(selected_fraction[0]),
                selected_fraction[1]
            ];
        }
        return undefined;
    };
    IrrationalManager.prototype.find_many_fractions = function (input, round_target) {
        var diff_of_squares = [];
        var flag = false;
        // Calculate without rounding and use that if it returns exactly zero. This fixes issues with small rationals getting confused.
        // Only an exact match (for non-repeating numbers, can't really hit the others)
        for (var possible_value in this.rationalTableTerminating) {
            if (this.rationalTableTerminating.hasOwnProperty(possible_value)) {
                var test_result = Math.pow((input - +possible_value), 2);
                if (test_result === 0) {
                    diff_of_squares.push([
                        this.rationalTableTerminating[possible_value],
                        test_result,
                    ]);
                    flag = true;
                    break;
                }
            }
        }
        if (!flag) {
            // Check non-terminating rationals
            for (var possible_value in this.rationalTableNonTerminating) {
                if (this.rationalTableNonTerminating.hasOwnProperty(possible_value))
                    diff_of_squares.push([
                        this.rationalTableNonTerminating[possible_value],
                        Math.pow((input - Utils_1.round(+possible_value, round_target)), 2),
                    ]);
            }
            // Check irrationals
            for (var possible_value in this.table) {
                if (this.table.hasOwnProperty(possible_value))
                    diff_of_squares.push([
                        this.table[possible_value],
                        Math.pow((input - Utils_1.round(+possible_value, round_target)), 2),
                    ]);
            }
        }
        diff_of_squares.sort(function (a, b) {
            return a[1] - b[1];
        });
        // This will always have more than 5 items
        // @ts-ignore
        return diff_of_squares.slice(0, 5);
    };
    IrrationalManager.prototype.fillTable = function (irrationals, depth) {
        var _this = this;
        if (depth === void 0) { depth = 5; }
        // Fill with rationals
        this.simpleRational(24);
        // Do all the irrationals
        irrationals.forEach(function (value) {
            _this.simpleIrrational(value[1], value[0], depth);
        });
    };
    IrrationalManager.prototype.simpleIrrational = function (irrational, irrational_string, depth) {
        this.simpleIrrationalNumerator(irrational, irrational_string, depth);
        this.simpleIrrationalDenominator(irrational, irrational_string, depth);
    };
    IrrationalManager.prototype.simpleRational = function (depth) {
        // Fill the rational table
        var terminating_fractions = SternBorcot_1.generateTerminatingSternBorcotTreeToDepth(depth, 20);
        for (var _i = 0, terminating_fractions_1 = terminating_fractions; _i < terminating_fractions_1.length; _i++) {
            var fraction = terminating_fractions_1[_i];
            var result = fraction.numerator / fraction.denominator;
            this.rationalTableTerminating[result] = {
                numerator: [fraction.numerator],
                denominator: [fraction.denominator],
            };
        }
        var non_terminating = SternBorcot_1.generateTerminatingSternBorcotTreeToDepth(depth, 20, false);
        for (var _a = 0, non_terminating_1 = non_terminating; _a < non_terminating_1.length; _a++) {
            var fraction = non_terminating_1[_a];
            var result = fraction.numerator / fraction.denominator;
            this.rationalTableNonTerminating[result] = {
                numerator: [fraction.numerator],
                denominator: [fraction.denominator],
            };
        }
    };
    IrrationalManager.prototype.simpleIrrationalNumerator = function (irrational, irrational_string, depth) {
        // TODO: remove redundancy on tree generation
        var fractions = SternBorcot_1.generateSternBorcotTreeToDepth(depth);
        for (var _i = 0, fractions_1 = fractions; _i < fractions_1.length; _i++) {
            var fraction = fractions_1[_i];
            var result = (irrational * fraction.numerator) / fraction.denominator;
            this.table[result] = {
                numerator: [irrational_string, fraction.numerator],
                denominator: [fraction.denominator],
            };
        }
    };
    IrrationalManager.prototype.simpleIrrationalDenominator = function (irrational, irrational_string, depth) {
        var fractions = SternBorcot_1.generateSternBorcotTreeToDepth(depth);
        for (var _i = 0, fractions_2 = fractions; _i < fractions_2.length; _i++) {
            var fraction = fractions_2[_i];
            var result = fraction.numerator / (fraction.denominator * irrational);
            this.table[result] = {
                numerator: [fraction.numerator],
                denominator: [irrational_string, fraction.denominator],
            };
        }
    };
    IrrationalManager.irrationals = Utils_1.master_irrationals;
    IrrationalManager.outputModeTable = {
        latex: OutputParsers_1.LatexParser,
        default: OutputParsers_1.DefaultParser,
        object: function (frac) { return frac; }
    };
    return IrrationalManager;
}(Utils_1.LookupManager));
exports.IrrationalManager = IrrationalManager;
//# sourceMappingURL=IrrationalManager.js.map